
import { Component, Prop } from 'vue-property-decorator';
import { SchemeScope } from '@/components/mixins/schemescope';
import { mixins } from 'vue-class-component';

@Component({
  components: {
    SchemeNodeComponent: () => import('./SchemeNode.vue'), // Done this way to avoid issue with recursive components
  },
  name: 'ViewSkillModal',
})
export default class ViewSkillModal extends mixins(SchemeScope) {
  @Prop() private schemeNodeId!: string;
  private popupStyle = null;
  private nodeId = '';

  async created() {
    this.nodeId = this.schemeNodeId;
    this.popupStyle = await this.$store.dispatch('nav/calculateStyle', {
      schemeSlug: this.slug,
      schemeNodeId: this.schemeNodeId,
      updateTheme: false,
    });
  }

  handleSkillChange(nodeId: string) {
    this.nodeId = nodeId;
    const element = document.getElementById('view-skill-modal');
    if (element) {
      element.scrollIntoView(true); // Scroll to top of modal
    }
  }
}
